module.exports = __webpack_public_path__ + "static/media/vts1.c63572c5.jpg";